"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateDonorFeesGive2Asia = void 0;
const enums_1 = require("../types/enums");
const constants_1 = require("../constants");
const utils_1 = require("../utils");
const calculateStripeFees_1 = require("./calculateStripeFees");
const calculateDonorFeesGive2Asia = ({ amount = 0, coverFees = false, feeCoveredBy = enums_1.FeeCoveredBy.User, isSandbox, cardCountryCode = 'US', // TODO: NOTE-SL - Give2Asia is only supported in US?
nonprofitCountryCode = 'US', applicationFeeSetting = constants_1.DEFAULT_APPLICATION_FEE_EMPLOYEE, applicationFeeAmountCap, donationProvider, }) => {
    if (donationProvider !== enums_1.DonationProvider.Give2Asia) {
        throw Error(`donationProvider must be ${enums_1.DonationProvider.Give2Asia}`);
    }
    const { providerFeeAmountCents, applicationFeeAmountCents, totalFeeAmountCents } = (0, calculateStripeFees_1.calculateStripeFee)({
        amountCents: amount * utils_1.CENTS_AMOUNT,
        accountCountryCode: 'US', // Because DCGF is registered in the US
        cardCountryCode,
        applicationFee: feeCoveredBy === enums_1.FeeCoveredBy.Deed ? 0 : applicationFeeSetting,
        applicationFeeAmountCentsCap: applicationFeeAmountCap * utils_1.CENTS_AMOUNT,
        coverFees,
        isSandbox,
    });
    return {
        providerFeeAmount: providerFeeAmountCents / utils_1.CENTS_AMOUNT,
        applicationFeeAmount: applicationFeeAmountCents / utils_1.CENTS_AMOUNT,
        totalFeeAmount: totalFeeAmountCents / utils_1.CENTS_AMOUNT,
    };
};
exports.calculateDonorFeesGive2Asia = calculateDonorFeesGive2Asia;
//# sourceMappingURL=calculateDonorFeesGive2Asia.js.map